(function ($) {
  // $ formatted selector to search for focusable items
  const focusableElementsString =
    'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]';
  const $modals = $('.accessible-modal');
  const $modalOverlay = $('#modalOverlay');
  const $modalCloseButtons = $('.js-accessible-modal-close');
  const $modelDiscardButtons = $('.js-accessible-modal-discard');
  const formHasError = $('.accessible-modal.error').length;
  const mobile_win_size = 768;
  // store the item that has focus before opening the modal window
  let focusedElementBeforeModal;

  $("[data-toggle='modal']").on('click', event => {
    const id = $(event.currentTarget).attr('data-target');
    const $modal = $(`#${id}`);
    if ($modal.length) {
      showModal($modal);
    }
  });

  if (formHasError) {
    const id = $('.accessible-modal.error').attr('id');
    if (id) {
      showModal($(`#${id}`));
    }
  }

  const $openModal = $('.accessible-modal.open');
  if ($openModal.length) {
    const id = $openModal.attr('id');
    showModal($(`#${id}`));
  }

  $modalCloseButtons.on('click', function () {
    const $modal = $(this).closest('.accessible-modal');
    hideModal($modal);
  });

  $modelDiscardButtons.on('click', function () {
    const $modal = $(this).closest('.accessible-modal');

    const $redirectUrl = $modal.find(
      'input[type="hidden"][name="submit_redirect"]'
    );

    if ($redirectUrl) {
      const $url = $redirectUrl.val();
      window.location.href = $url;
    }

    hideModal($modal);
  });

  $modals.on('keydown', event => {
    trapTabKey($(event.currentTarget), event);
  });

  $('body').on('keydown', event => {
    trapEscapeKey($(event.currentTarget), event);
  });

  const trapEscapeKey = ($obj, event) => {
    if (event.key === 'Escape') {
      const $cancelElement = $obj.find('.js-accessible-modal-close');
      $cancelElement.click();
      event.preventDefault();
    }
  };

  const trapTabKey = ($obj, event) => {
    if (event.which === 9) {
      const $focusableItems = $obj
        .find('*')
        .filter(focusableElementsString)
        .filter(':visible');

      const $focusedItem = $(':focus');
      const index = $focusableItems.index($focusedItem);
      const length = $focusableItems.length;
      if (event.shiftKey) {
        if (index === 0) {
          $focusableItems.eq(length - 1).focus();
          event.preventDefault();
        }
      } else {
        if (index === length - 1) {
          $focusableItems.eq(0).focus();
          event.preventDefault();
        }
      }
    }
  };

  const setFocusToFirstItemInModal = $obj => {
    // get list of all children elements in given object
    const children = $obj.find('*');

    // set the focus to the first keyboard focusable item
    children.filter(focusableElementsString).filter(':visible').first().focus();
  };

  const showModal = $modal => {
    $modalOverlay.css('display', 'block'); // insert an overlay to prevent clicking and make a visual change to indicate the main apge is not available
    $modal.addClass('open'); // make the modal window visible
    $modal.attr('aria-hidden', 'false'); // mark the modal window as visible

    // save current focus
    focusedElementBeforeModal = $(':focus');
    setFocusToFirstItemInModal($modal);
  };

  const hideModal = () => {
    $modalOverlay.css('display', 'none'); // remove the overlay in order to make the main screen available again
    $modals.removeClass('open'); // hide the modal window
    $modals.attr('aria-hidden', 'true'); // mark the modal window as hidden

    // set focus back to element that had it before the modal was opened
    focusedElementBeforeModal?.focus();
    if (formHasError) {
      const url = window.location.href;
      window.location.href = url;
    }
  };

  function handleStickySection(stickyEl) {
    $(window).on('scroll', function () {
      let fromTop = $(window).scrollTop();
      if (
        fromTop >= $('.accessible-modal').offset().top &&
        fromTop <
          $('.accessible-modal').offset().top +
            $('.accessible-modal').outerHeight() -
            stickyEl.outerHeight() -
            100
      ) {
        stickyEl.css('position', 'fixed');
        stickyEl.addClass('fixed');
      } else {
        stickyEl.css('position', 'absolute');
        stickyEl.removeClass('fixed');
      }
    });
  }

  $(window)
    .on('resize', function () {
      let stickyEl = $('.js-close');
      let offset = 0;

      if ($(window).width() < mobile_win_size && stickyEl.length > 0) {
        handleStickySection(stickyEl, false, offset);
      } else if ($(window).width() >= mobile_win_size && stickyEl.length > 0) {
        stickyEl.css('top', 6);
        stickyEl.css('position', 'absolute');
        stickyEl.removeClass('fixed');
      }
    })
    .resize();
})($);
